export default {
  clear(state) {
    state.type = ''
    state.partner = {}

    state.email = ''
    state.password = ''
    state.confirmPassword = ''

    state.firstName = ''
    state.lastName = ''
    state.phone = ''
    state.birthdate = ''
    state.gender = 'MALE'

    state.line1 = ''
    state.line2 = ''
    state.city = ''
    state.state = ''
    state.zip = ''
  },
  setType(state, type) {
    state.type = type
  },
  setPartner(state, partner) {
    state.partner = partner
  },
  setCredentials(state, credentials) {
    state.email = credentials.email
    state.password = credentials.password
    state.confirmPassword = credentials.confirmPassword
  },
  setProfile(state, profile) {
    state.firstName = profile.firstName
    state.lastName = profile.lastName
    state.phone = profile.phone
    state.birthdate = profile.birthdate
    state.gender = profile.gender
    state.ssn = profile.ssn
  },
  setAddress(state, address) {
    state.line1 = address.line1
    state.line2 = address.line2
    state.city = address.city
    state.state = address.state
    state.zip = address.zip
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/registration/mutations.js